export default __webpack_public_path__ + "static/media/half-star.0075791c.svg";